let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("axMFF")).then(() => parcelRequire('1djCF'));